var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyTorchImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.255 63.7066C124.044 77.4963 124.044 99.6173 110.255 113.503C96.7521 127.293 74.5353 127.293 60.7456 113.503C46.9559 99.7131 46.9559 77.4963 60.7456 63.7066L85.4522 39V51.3533L83.1539 53.6516L66.7786 70.0269C56.4363 80.1777 56.4363 96.8402 66.7786 107.183C76.9294 117.525 93.592 117.525 103.934 107.183C114.277 97.0318 114.277 80.3692 103.934 70.0269L110.255 63.7066ZM97.9013 62.1744C95.3627 62.1744 93.3047 60.1164 93.3047 57.5778C93.3047 55.0392 95.3627 52.9813 97.9013 52.9813C100.44 52.9813 102.498 55.0392 102.498 57.5778C102.498 60.1164 100.44 62.1744 97.9013 62.1744Z",
    fill: "#EE4C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyTorchImg);
export default __webpack_public_path__ + "static/media/PyTorchImg.cc912317cdd6e8d07ea7f9b8707b83a1.svg";
export { ForwardRef as ReactComponent };